import { createContext } from 'use-context-selector'
import { UsersPageContextProps } from './types'

export const UsersPageContext = createContext({} as UsersPageContextProps)
